import { render, staticRenderFns } from "./DyComprehensiveAppraisal2.vue?vue&type=template&id=5f5165bd&scoped=true&"
import script from "./DyComprehensiveAppraisal2.vue?vue&type=script&lang=js&"
export * from "./DyComprehensiveAppraisal2.vue?vue&type=script&lang=js&"
import style0 from "./DyComprehensiveAppraisal2.vue?vue&type=style&index=0&id=5f5165bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5165bd",
  null
  
)

export default component.exports